import { render } from "./LoginRouteBranch.vue?vue&type=template&id=c723055c"
import script from "./LoginRouteBranch.vue?vue&type=script&lang=js"
export * from "./LoginRouteBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/LoginRouteBranch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c723055c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c723055c', __exports__)) {
    api.reload('c723055c', __exports__)
  }
  
  module.hot.accept("./LoginRouteBranch.vue?vue&type=template&id=c723055c", () => {
    api.rerender('c723055c', render)
  })

}


export default __exports__